/* ==============================================================================
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
============================================================================== */

import React, { useEffect, useState } from 'react';
import { ref, onValue, onChildChanged } from 'firebase/database';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

// @mui material components
import Icon from '@mui/material/Icon';
import Grid from '@mui/material/Grid';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox';

// Material Dashboard 2 PRO React examples
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import Footer from 'examples/Footer';
import { APP_STATE } from 'services/Define';
import db from 'services/Firebase';

// Component
import Navbar from 'examples/Navbars/NavBar';
import DashboardPosCart from './DashboardPosCart';
import DashboardPosMobile from './DashboardPosMobile';
import DashboardPosProblem from './DashboardPosProblem';
import StatisticCard from './StatisticCard';
import DbCartListDelete from './DbCartListDelete';
import DbCancel from './DbCancel';
import PosDiscountApprove from './PosDiscountApprove';
import PosKeepApprove from './PosKeepApprove';

function DashboardPos() {
  const mod = 'dashboard_pos';
  const { t, i18n } = useTranslation();
  const app = useSelector((state) => state[APP_STATE]);
  const [notify, setNotify] = useState(null);
  const [countReturn, setCountReturn] = useState(0);
  const [countCancel, setCountCancel] = useState(0);
  const [countDiscount, setCountDiscount] = useState(0);
  const [countKeep, setCountKeep] = useState(0);
  const [countCart, setCountCart] = useState(0);
  const [countCartList, setCountCartList] = useState(0);
  const [modalReturn, setModalReturn] = useState(false);
  const [modalCancel, setModalCancel] = useState(false);
  const [modalCartList, setModalCartList] = useState(false);
  const [modalDiscount, setModalDiscount] = useState(false);
  const [modalKeep, setModalKeep] = useState(false);
  const [modalCart, setModalCart] = useState(false);

  const showNotify = (msg, color) => {
    setNotify(
      <Snackbar
        open
        autoHideDuration={3000}
        onClose={() => setNotify(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert onClose={() => setNotify(null)} severity={color} variant='filled'>
          {msg}
        </Alert>
      </Snackbar>
    );
  };

  const openReturn = () => {
    setModalReturn(true);
  };

  const openDiscount = () => {
    setModalDiscount(true);
  };

  const openKeep = () => {
    setModalKeep(true);
  };

  const openCart = () => {
    setModalCart(true);
  };

  const openCancel = () => {
    setModalCancel(true);
  };

  const openCartList = () => {
    setModalCartList(true);
  };

  const handleNotify = async () => {
    if (app.pos.pos_device !== '') {
      onValue(ref(db, `pos/${app.pos.pos_device}`), (snapshot) => {
        const data = snapshot.val();
        // console.log(data.pos_cartlist);

        if (data.pos_return !== undefined) {
          if (countReturn !== data.pos_return && data.pos_return > 0) {
            showNotify('แจ้งปัญหา', 'error');
          }
          setCountReturn(data.pos_return);
        }
        if (data.pos_cartlist !== undefined) {
          if (countCartList !== data.pos_cartlist && data.pos_cartlist > 0) {
            showNotify('ขอลบรายการ', 'error');
          }
          setCountCartList(data.pos_cartlist);
        }
        if (data.pos_cancel !== undefined) {
          if (countCartList !== data.pos_cancel && data.pos_cancel > 0) {
            showNotify('ขอยกเลิกบิล', 'error');
          }
          setCountCancel(data.pos_cancel);
        }
        if (data.pos_discount !== undefined) {
          if (countDiscount !== data.pos_discount && data.pos_discount > 0) {
            showNotify('ขอส่วนลด', 'error');
          }
          setCountDiscount(data.pos_discount);
        }
        if (data.pos_keep !== undefined) {
          if (countKeep !== data.pos_keep && data.pos_keep > 0) {
            showNotify('ขอยกเลิกบิลเก็บ', 'error');
          }
          setCountKeep(data.pos_keep);
        }
        if (data.pos_cart !== undefined) {
          if (countCart !== data.pos_cart && data.pos_cart > 0) {
            // Func.notifyBrowser("ขอยกเลิกตะกร้า");
            showNotify('ขอยกเลิกตะกร้า', 'error');
          }
          setCountCart(data.pos_cart);
        }
      });
      // onChildChanged(ref(db, `pos/${app.pos.pos_device}`), (snapshot) => {
      //   const { key } = snapshot;
      //   const value = snapshot.val();

      //   switch (key) {
      //     case 'pos_return':
      //       if (value > countReturn) showNotify('แจ้งปัญหา', 'error');
      //       setCountReturn(value);
      //       break;
      //     case 'pos_cartlist':
      //       if (value > countCartList) showNotify('ขอลบรายการ', 'error');
      //       setCountCartList(value);
      //       break;
      //     case 'pos_cancel':
      //       if (value > countCancel) showNotify('ขอยกเลิกบิล', 'error');
      //       setCountCancel(value);
      //       break;
      //     case 'pos_discount':
      //       if (value > countDiscount) showNotify('ขอส่วนลด', 'error');
      //       setCountDiscount(value);
      //       break;
      //     case 'pos_keep':
      //       if (value > countKeep) showNotify('ขอยกเลิกบิลเก็บ', 'error');
      //       setCountKeep(value);
      //       break;
      //     case 'pos_cart':
      //       if (value > countCart) {
      //         showNotify('ขอยกเลิกตะกร้า', 'error');
      //       }
      //       setCountCart(value);
      //       break;
      //     default:
      //       break;
      //   }
      // });
    }
  };

  const renderStat = () => {
    return (
      <MDBox>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={4} lg={2}>
            <MDBox mb={1.5}>
              <StatisticCard
                color='light'
                icon='change_circle'
                title='เปลี่ยนสินค้า'
                count={countReturn}
                callback={openReturn}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={2}>
            <MDBox mb={1.5}>
              <StatisticCard
                color='light'
                icon='highlight_off'
                title='ยกเลิกบิล'
                count={countCancel}
                callback={openCancel}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={2}>
            <MDBox mb={1.5}>
              <StatisticCard
                color='light'
                icon='delete_outline'
                title='ลบรายการ'
                count={countCartList}
                callback={openCartList}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={2}>
            <MDBox mb={1.5}>
              <StatisticCard
                color='light'
                icon='discount'
                title='ขอส่วนลด'
                count={countDiscount}
                callback={openDiscount}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={2}>
            <MDBox mb={1.5}>
              <StatisticCard
                color='light'
                icon='archive'
                title='ลบจัดเก็บ'
                count={countKeep}
                callback={openKeep}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={2}>
            <MDBox mb={1.5}>
              <StatisticCard
                color='light'
                icon='remove_shopping_cart'
                title='ลบตะกร้า'
                count={countCart}
                callback={openCart}
              />
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
    );
  };

  const renderReturn = () => {
    return (
      <Dialog
        open={modalReturn}
        maxWidth='xl'
        keepMounted
        aria-describedby='dialog-return'
        fullWidth
        onClose={() => setModalReturn(false)}
      >
        <DialogTitle>
          เปลี่ยนสินค้า
          <IconButton
            aria-label='close'
            onClick={() => setModalReturn(false)}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Icon>close</Icon>
          </IconButton>
        </DialogTitle>
        <DialogContent dividers sx={{ p: 2, minHeight: 500 }}>
          {modalReturn ? <DashboardPosProblem /> : null}
        </DialogContent>
      </Dialog>
    );
  };

  const renderCancel = () => {
    return (
      <Dialog
        open={modalCancel}
        maxWidth='xl'
        keepMounted
        aria-describedby='dialog-cartlist'
        fullWidth
        onClose={() => setModalCancel(false)}
      >
        <DialogTitle>
          ลบรายการ
          <IconButton
            aria-label='close'
            onClick={() => setModalCancel(false)}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Icon>close</Icon>
          </IconButton>
        </DialogTitle>
        <DialogContent dividers sx={{ p: 2 }}>
          {modalCancel ? <DbCancel setModal={setModalCancel} /> : null}
        </DialogContent>
      </Dialog>
    );
  };

  const renderCartList = () => {
    return (
      <Dialog
        open={modalCartList}
        maxWidth='xl'
        keepMounted
        aria-describedby='dialog-cartlist'
        fullWidth
        onClose={() => setModalCartList(false)}
      >
        <DialogTitle>
          ลบรายการ
          <IconButton
            aria-label='close'
            onClick={() => setModalCartList(false)}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Icon>close</Icon>
          </IconButton>
        </DialogTitle>
        <DialogContent dividers sx={{ p: 2 }}>
          {modalCartList ? <DbCartListDelete /> : null}
        </DialogContent>
      </Dialog>
    );
  };

  const renderDiscountApprove = () => {
    return (
      <Dialog
        open={modalDiscount}
        maxWidth='xl'
        keepMounted
        aria-describedby='dialog-cartlist'
        fullWidth
        onClose={() => setModalDiscount(false)}
      >
        <DialogTitle>
          ขอส่วนลด
          <IconButton
            aria-label='close'
            onClick={() => setModalDiscount(false)}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Icon>close</Icon>
          </IconButton>
        </DialogTitle>
        <DialogContent dividers sx={{ p: 2 }}>
          {modalDiscount ? <PosDiscountApprove /> : null}
        </DialogContent>
      </Dialog>
    );
  };

  const renderKeepApprove = () => {
    return (
      <Dialog
        open={modalKeep}
        maxWidth='xl'
        keepMounted
        aria-describedby='dialog-cartlist'
        fullWidth
        onClose={() => setModalKeep(false)}
      >
        <DialogTitle>
          ลบการจัดเก็บ
          <IconButton
            aria-label='close'
            onClick={() => setModalKeep(false)}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Icon>close</Icon>
          </IconButton>
        </DialogTitle>
        <DialogContent dividers sx={{ p: 2 }}>
          {modalKeep ? <PosKeepApprove /> : null}
        </DialogContent>
      </Dialog>
    );
  };

  const renderPos = () => {
    return (
      <MDBox>
        <DashboardPosCart />
        <DashboardPosMobile />
      </MDBox>
    );
  };

  useEffect(() => {
    i18n.changeLanguage(app.lang);
  }, []);

  useEffect(() => {
    handleNotify();
  }, []);

  return (
    <DashboardLayout>
      <Navbar route={[t(`menu.dashboard`), t(`menu.dashboard_pos`)]} />
      <MDBox py={3}>
        {renderStat()}
        {renderPos()}
      </MDBox>
      <Footer />
      {renderReturn()}
      {renderCartList()}
      {renderCancel()}
      {renderDiscountApprove()}
      {renderKeepApprove()}
      {notify}
    </DashboardLayout>
  );
}

export default DashboardPos;
